/** =========================================================
 * Order task types controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-order-task-types')
    .controller('OrderTaskTypesController', OrderTaskTypesController);

  OrderTaskTypesController.$inject = [
    '$rootScope',
    '$scope',
    '$api',
    '$state',
    '$stateParams',
    '$translate'
  ];

  function OrderTaskTypesController(
    $rootScope,
    $scope,
    $api,
    $state,
    $stateParams,
    $translate
  ) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page order task types',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'order_task_type',
        getDataParams: {
          order: {
            created_at: 'desc'
          },
          with: ['workgroup.users'],
          count: ['order_tasks']
        },
        filters: angular.copy($stateParams.filters),
        resources: ['workgroup'],
        fields: [{
          title: 'Slug',
          key: 'slug',
          order: true
        }, {
          title: 'Title',
          key: 'name',
          order: true
        }, {
          title: 'Workgroup',
          key: 'workgroup_id',
          value: function (item) {
            return item.workgroup.name;
          },
          order: true
        }, {
          title: 'Users',
          key: null,
          value: function (item) {
            return item.workgroup.users.map(function (user) {
              return user.name;
            }).join(', ');
          }
        }],
        add: {
          template: 'app/views/dialogs/item-order-task-type.html'
        },
        edit: {
          template: 'app/views/dialogs/item-order-task-type.html',
          except: [
            'workgroup',
            'cname',
            'order_tasks_count'
          ]
        },
        delete: {},
        linkButtons: [{
          icon: 'icon-check',
          class: 'btn-info',
          title: 'Order task type',
          permission: $rootScope.helpers.hasPermissionTo('order_task view'),
          action: function (item) {
            try {
              $state.go('app.page-order-tasks', {
                filters: [{
                  name: $translate.instant('Order task type') + ': ' + item.cname,
                  attr: 'where',
                  value: [
                    ['order_task_type_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.order_tasks_count;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
